import {httpClient} from "../../api.js";


export const getCourierTransactions = async ({type, limit=10, offset=0, userId=null, startCreatedAt=null, endCreatedAt=null}) => {
  try {
    const params = new URLSearchParams();

    params.append('limit', limit);
    params.append('offset', offset);

    if (userId) {
      params.append("user_id", userId)
    }

    if (startCreatedAt) {
      params.append('start_created_at', startCreatedAt);
    }

    if (endCreatedAt) {
      params.append('end_created_at', endCreatedAt);
    }

    if(type){
      params.append('type', type)
    }

    const queryString = params.toString();

    const response = await httpClient.get(`/transactions?${queryString}`);
    return response.data;
  } catch (error) {
    console.error('Failed to fetch courier payments:', error);
    return [];
  }
};


export const getCourierDropStatistics = async ({userId}) => {
  try {
    const response = await httpClient.get(`/courier/${userId}/drop-statistics`);
    return response.data;
  } catch (error) {
    console.error('Failed to fetch courier payments:', error);
    return [];
  }
};
